import { useLayoutEffect, type RefObject } from 'react';

const SELECTED = '[data-selected="true"]';

/**
 * Opens a picker list on its selected option: centers it once, scrolling only the list and never its host. A popover
 * lays its content out after mounting it, so a list without a size yet is centered as soon as it gets one.
 */
const useCenterSelected = (listRef: RefObject<HTMLElement | null>) => {
	useLayoutEffect(() => {
		const list = listRef.current;
		if (!list) return undefined;
		const center = () => {
			const selected = list.querySelector<HTMLElement>(SELECTED);
			if (!selected) return true;
			if (!list.clientHeight || !selected.offsetHeight) return false;
			const offset = selected.getBoundingClientRect().top - list.getBoundingClientRect().top;
			list.scrollTop += offset - (list.clientHeight - selected.offsetHeight) / 2;
			return true;
		};
		if (center()) return undefined;
		const observer = new ResizeObserver(() => {
			if (center()) observer.disconnect();
		});
		observer.observe(list);
		return () => observer.disconnect();
	}, [listRef]);
};

export { useCenterSelected };
